// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  spaceBountyId: __t.u64().primaryKey().name("space_bounty_id"),
  identity: __t.identity(),
  pirateKey: __t.string().name("pirate_key"),
  paidSov: __t.i64().name("paid_sov"),
  at: __t.timestamp(),
});
